export default {
  title: '交換記録',
  giftInfo: 'ギフト情報',
  giftInfoPlaceholder: 'キーワードで検索してください',
  memberInfo: '会員情報',
  memberInfoPlaceholder: 'キーワードで検索してください',
  shipStatus: '配送状況',
  exchangeTime: '交換時間',
  startDate: '開始時間',
  endDate: '終了時間',
  country: '国',
  exchangePrice: '交換価格',
  exchangeQty: '交換数量',
  contactPhone: '連絡先電話',
  shippingAddress: '配送先住所',
  spec: '仕様',
  specName: '仕様',
  singleSpec: '単一仕様',
  statusPending: '処理待ち',
  statusShipped: '発送済み',
  statusAll: 'すべて',
  statusRedeemed: '交換済み',
  statusCompleted: '完了',
  statusCancelled: 'キャンセル',
  statusFailed: '失敗',
  ship: '発送',
  detail: '詳細',
  shipModalTitle: '発送',
  shipDetailTitle: '発送情報',
  expressCompany: '配送会社',
  expressCompanyPlaceholder: '配送会社名を入力してください',
  trackingNo: '追跡番号',
  trackingNoPlaceholder: '追跡番号を入力してください',
  remark: '備考',
  remarkPlaceholder: '備考を入力してください',
  expressCompanyRequired: '配送会社を入力してください',
  trackingNoRequired: '追跡番号を入力してください',
  timeRequired: '交換時間を選択してください',
};
